import Typography from '@/components/shared/typography/typography.component';
import { ImperfectionReportItem, ImperfectionReportSection } from '@/types';
import UnFultyImprefectionItem from './unfultyImprefectionItem.component';
import Image from 'next/image';

const GoodPartsContent = ({
    arr,
    IS_RTL,
    item,
}: {
    arr: ImperfectionReportItem[];
    IS_RTL: boolean;
    item: ImperfectionReportSection;
}) => {
    return (
        <div className="pt-2">
            <div className="flex justify-items-center content-center gap-x-2.5 mb-2">
                <div className='flex-shrink-0'>
                    <Image
                        width={24}
                        height={24}
                        style={{ objectFit: 'contain' }}
                        src={item?.section_good_icon}
                        alt={item.name_en}
                    />
                </div>
                <div className="flex-col content-center">
                    <div className="text-gray-700 text-sm font-semibold leading-tight">
                        {IS_RTL ? item.name_ar : item.name_en}
                    </div>
                    <div className="text-600 text-xs font-normal leading-[18px]">
                        {IS_RTL ? item.subtitle_ar : item.subtitle_en}
                    </div>
                </div>
            </div>
            <div className='bg-white pt-4 px-3 border border-gray-200 rounded-xl'>
                {arr.map((item, index) => {
                    let tags: string | null = null;
                    if (item.tags) {
                        tags = item.tags
                            .map(item => (IS_RTL ? item.tag_ar : item.tag_en))
                            .join(' - ');
                    }
                    let isRemark = false;
                    let remarkNotes: string[] | null = null;
                    if (arr.length === 1 && item.item_type === 'TEXT_ONLY') {
                        isRemark = true;
                        remarkNotes = IS_RTL
                            ? item?.comment_ar?.split('/')
                            : item?.comment_en?.split('/');
                    }
                    return (
                        <div key={index}>
                            {isRemark ? (
                                <div
                                    className="flex justify-between items-center mb-3"
                                    key={`${item.name_en} accordion-item`}
                                >
                                    <Typography
                                        variant="body2Medium"
                                        className="!text-gray-700"
                                    >
                                        {remarkNotes?.map(note => {
                                            return (
                                                <li key={`${note} remark-note`}>
                                                    {note}
                                                </li>
                                            );
                                        })}
                                    </Typography>
                                </div>
                            ) : (
                                <UnFultyImprefectionItem
                                    item={item}
                                    tags={tags}
                                    key={`${item.name_en}${index}`}
                                    IS_RTL={IS_RTL}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default GoodPartsContent;
